<div id="container-load" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="center center">
    <div id="load" class="spinner-border color-accent" role="status">
        <!-- <span class="sr-only">Loading...</span> -->
        <mat-spinner></mat-spinner>
    </div>
</div>